import { render, staticRenderFns } from "./TabSchedule.vue?vue&type=template&id=0975a890"
import script from "./TabSchedule.vue?vue&type=script&lang=js"
export * from "./TabSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports